import { render, staticRenderFns } from "./StockDetails.vue?vue&type=template&id=a4b16600"
import script from "./StockDetails.vue?vue&type=script&lang=js"
export * from "./StockDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports